import config from './utils/config';

// detect internet explorer
var isIE = !!window.MSInputMethodContext && !!document.documentMode;

if (isIE || config.allowPolyFill) {
    console.log('@polyfill.Etngu using polyfills');
    // create promise polyfill script tag
    var promiseScript = document.createElement('script');
    promiseScript.type = 'text/javascript';
    promiseScript.src = 'https://cdn.jsdelivr.net/npm/promise-polyfill@8.2.0/dist/polyfill.min.js';

    // create fetch polyfill script tag
    var fetchScript = document.createElement('script');
    fetchScript.type = 'text/javascript';
    fetchScript.src = 'https://cdn.jsdelivr.net/npm/whatwg-fetch@3.6.1/dist/fetch.umd.min.js';

    // add polyfills to head element
    document.head.appendChild(promiseScript);
    document.head.appendChild(fetchScript);
}
